<template>
  <table>
    <tr>
      <th>サイズ</th>
      <td>A5サイズ（148mm × 210mm）</td>
    </tr>
    <tr>
      <th>厚さ</th>
      <td>約9mm</td>
    </tr>
    <tr>
      <th>ページ数</th>
      <td>96ページ</td>
    </tr>
    <tr>
      <th>用紙</th>
      <td>
        表紙：マット系アート紙<br />
        本文：マット紙
      </td>
    </tr>
    <tr>
      <th>印刷カラー</th>
      <td>フルカラー4色刷り</td>
    </tr>
  </table>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "CoverSpecTable"
});
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  font-size: 12px;
  line-height: 150%;
  overflow: hidden;
}

table th,
table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

table tr:last-child th,
table tr:last-child td {
  border-bottom: none;
}

table th {
  background: #f5f5f5;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
